import { Component, OnInit } from '@angular/core';
import { LoaderService } from './shared/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'recon-ease';
  constructor(private loaderService: LoaderService){}

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }

}
